(ns teamoesterreich.admin-mode.user.user-card-messages
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.admin-mode.data.userMessages :as d-userMessages]

            [reagent-material-ui.icons.expand-more :refer [expand-more]]
            [reagent-material-ui.icons.expand-less :refer [expand-less]]

            ))



(defn unParseDateFieldToTimestamp [ts]
  (if (and ts (> (count ts) 0))
    (str (subs ts 6 8) "." (subs ts 4 6) "." (subs ts 0 4) " " (subs ts 9 11) ":" (subs ts 11 13))
    "")
  ;(let [date (if ts (.toDate ts) (js/Date.))]  (goog.string.format "%04d-%02d-%02d %02d:%02d" (.getFullYear date) (inc (.getMonth date)) (.getDate date) (.getHours date) (.getMinutes date))    )
  )





(defn message-block [type title date message sender]
  (let [!st (r/atom {:open false})]
    (fn []
      [mui/grid
       {:container false
        :xs        12                                       ;extra-small: 0px
        :style     {:padding "15px 15px 0 15px"}
        }
       [mui/card
        {:variant "outlined"}
        [mui/card-content {
                           }
         [mui/grid {:container true}
          [mui/grid {:item true :md 8 :xl 10}
           [mui/typography {:variant "body1" :gutterBottom true} date "  " type "      " [:span {:style {:color "blue"}} sender]]]
          [mui/grid {:item true :md 4 :xl 2 :textAlign "right"}
           (when (not= "sms" type)
             [mui/button {:size    "small" :color "secondary"
                          :endIcon (r/as-element (if (:open @!st) [expand-less] [expand-more]))
                          :onClick (fn [] (js/console.log "message-block click" (:open @!st)) (swap! !st assoc :open (not (:open @!st))))
                          } (if (:open @!st) "Fertig" "Inhalt lesen ...")])]

          ]
         (if (= "sms" type)
           [mui/typography {:variant "body1" :component "p" :style {}} message]
           [mui/typography {:variant "body1" :component "p" :style {:fontWeight "bold"}} title])
         ]
        [mui/collapse {:in (:open @!st) :timeout "auto"}
         [mui/card-content {}
          [mui/typography {:variant "body1" :gutterBottom true} message]
          ]

         ]

        ]
       ]
      )))




(defn get-it [!actual-user !st]
  (let [!messages (r/cursor !st [:messages])]
    ;(log/debug "################ messages!! " @!messages)
    [mui/card {:style {:textAlign "left"}}
     [mui/card-header
      {:subheader "Nachrichten"}]
     (if-not @!messages
       (do
         (d-userMessages/get-user-messages (:user-tomId @!actual-user)
                                           (fn [list]
                                             (reset! !messages list)
                                             ))
         [mui/card-content
          [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
          [:br]
          [:br]
          [:br]
          [mui/typography "Lade Nachrichten... "]])
       [mui/card-content
        (for [{:keys [key userMessage-date date-str userMessage-message userMessage-title type userMessage-sender]}
              (reverse (sort-by :userMessage-date (map (fn [[k d]] (assoc d :key k :date-str (unParseDateFieldToTimestamp (:userMessage-date d)))) @!messages)))]
          ^{:key (str "message-" key)} [message-block type userMessage-title date-str userMessage-message userMessage-sender]
          )]
       )
     [mui/card-actions

      ]]))